var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.mode === 'view' ? '返 回' : '取 消')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }